import { Menu } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { isMobile } from 'react-device-detect';
import { I18nextProvider, useTranslation } from "react-i18next";
import SettingsWindow from "../../screens/adminSettings/adminSettings";
import i18n from "i18next";
import iconMap from "../../utils/left-nav-icons-map";
import { MenuContext } from "../../MenuProvider";
interface Props {
	visible: boolean;
	setVisible: (val: any) => void;
	isShowSideDrawer: any;
}

const SideDrawer: React.FC<Props> = ({
	visible,
	isShowSideDrawer
}) => {

	const { t } = useTranslation();

	const { menuItems } = useContext(MenuContext);

	const navigate = useNavigate();
	const location = useLocation();

	const [selectedKey, setSelectedKey] = useState<string[]>([]);
	const [current, setCurrent] = useState("");

	let [items, setItems] = useState<any[]>([]);

	const getKeyFromUrl = () => {
		let pathname = location.pathname;

		if(pathname.startsWith("/")) {			// pathname = 
			pathname = pathname.substring(1);
		}

		return pathname.split("/")[0];
	};

	useEffect(() => {

		const itemsList = menuItems.map((menu:any) => {

			return {
				label: <span>{t(menu.mainMenuName)}</span>,
				key: menu.mainMenuCode,
				icon: iconMap.get(menu.icon as string)
			}
		});



		if (itemsList.length > 0) {
			setItems(itemsList);
			setSelectedKey([itemsList[0].key]);
		}

	}, [menuItems, t]);

	useEffect(() => {
		let key = getKeyFromUrl();
		
		if(key !== "" && key.length > 1) {
			setSelectedKey([key]);
		} 

		if (current === "") {
			setCurrent(key);
			setSelectedKey([key]);
		}

		if (isMobile) {
			isShowSideDrawer(!visible);
		}

	}, [current, location]);


	const [settingsOpen, setSettingsOpen] = useState<boolean>(false);

	const handleOnSelect = (item: any) => {

		if (item.key === "setting") {
			setSettingsOpen(true);
		} else {
			navigate('/' + item.key);
			setSelectedKey([item.key]);
		}
	}

	return (
		<>
			<I18nextProvider i18n={i18n}>
				<Menu 
				 selectedKeys={selectedKey} defaultOpenKeys={selectedKey} className="sider-menu-main-box text-base font-medium" items={items} onSelect={(item) => handleOnSelect(item)} >
				</Menu>
			</I18nextProvider>

			<SettingsWindow open={settingsOpen} close={() => setSettingsOpen(false)} ></SettingsWindow>


		</>
	);
};
export default SideDrawer;
